import { getProductList } from '@/api/server/product'
import { getCategoryList } from '@/api/server/category'
import { getClassification } from '@/api/server/classification'

import { getJssdk } from '@/api/server/wechat'
import wx from "weixin-js-sdk";

import infiniteScroll from 'vue-infinite-scroll'

import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import commonMixin from '@/mixin/common'
import Banner from '@/components/Banner'
import Contact from '@/components/Contact'
import Product from '@/components/Product'
import Tabbar from '@/components/Tabbar'
import Osearch from '@/components/osearch'


// Vue.use(infiniteScroll)

// import infiniteScroll from 'vue-infinite-scroll'
// new Vue({
//   directives: {infiniteScroll}
// })

const defaultPageData = {
  page: 1,
  pagesize: 6,
  category: null,
  order_field: 'time',
  order: null,
  keyword: null,
  cid: null
}
export default {
  name: 'IndexPage',
  mixins: [commonMixin],
  directives: {
    infiniteScroll
  },
  data() {
    return {
      list: [],
      queryPage: Object.assign({}, defaultPageData),
      // pagesize: 6,
      // page: 1,
      // categoryId: null,
      // activeName: 'time',
      // order: null,
      // key: null,
      // cid: null,

      retSize: 6,
      total: 0,
      loading: false,
      hots: [],
      categoryList: [],
      price: 0,
      classification: [],
      banner: null,
      timer: null,
      isFixed: false,
      bannerImg: [],
      isScroll: false,
      jsSdk: {},
      fullUrl: window.location.protocol + '//' + window.location.hostname + this.$route.fullPath
    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent,
    Banner,
    Contact,
    Product,
    Tabbar,
    Osearch
  },
  computed: {
    noMore() {
      let more = false
      if (this.retSize !== this.queryPage.pagesize) {
        more = true
      }
      return more
    },
    disabled() {
      return this.loading || this.noMore
    },
    priceUpStatus() {
      if (this.queryPage.order_field === 'price' && this.queryPage.order === 'desc') {
        return true
      } else {
        return false
      }
    },
    priceDownStatus() {
      if (this.queryPage.order_field === 'price' && this.queryPage.order === 'asc') {
        return true
      } else {
        return false
      }
    },
    categoryName() {
      let classification = this.classification
      let cid = this.queryPage.cid
      if (cid && classification) {
        let category = this.classification.find(item => {
          return (item.id).toString() === cid
        })
        if (category) {
          return category.title
        }
      }
    }
  },
  methods: {
    onSearchList (key) {
      if (!key) {
        this.warning('请输入关键词')
      }
      this.list = []
      this.queryPage = Object.assign({}, defaultPageData)
      this.queryPage.keyword = key
      this.loadList()
    },
    onShow(e) {
      this.bannerImg.push(e)
    },
    onNews(id) {
      this.$router.push({
        name: 'news',
        query: {
          id: id
        }
      })
    },
    onMessage() {
      this.$router.push({
        name: 'message'
      })
    },
    oformatDate(str) {
      return formatDate(str)
    },
    onSelect(item) {
      this.queryPage.category = item.id
      this.queryPage.page = 1
      this.loadList()
    },
    onAll() {
      this.queryPage.category = 0
      this.queryPage.page = 1
      this.loadList()
    },
    onActive(value) {
      this.queryPage.order_field = value
      if (value === 'price') {
        if (this.queryPage.order && this.queryPage.order === 'desc') {
          this.queryPage.order = 'asc'
        } else {
          this.queryPage.order = 'desc'
        }
      }
      this.loadList()
    },
    onDetail(id) {
      this.$router.push({
        name: 'detail',
        query: {
          id: id
        }
      });
    },
    currentPageChange(currentPage) {
      this.queryPage.page = currentPage
      this.loadList()
    },
    _getCategory() {
      let query = {
        cid: this.queryPage.cid
      }
      getCategoryList(query).then((res) => {
        if (res.code === 200) {
          this.categoryList = res.data
        }
      })
    },
    // 加载列表
    loadList() {
      this.loading = true
      getProductList(this.queryPage).then((data) => {
        this.loading = false
        if (data.code === 200 && data.data && data.data.data) {
          let rdata = data.data
          this.retSize = rdata.data.length
          if (this.list && this.list.length > 0) {
            this.list = this.list.concat(rdata.data)
          } else {
            this.list = rdata.data
          }
          this.queryPage.page = this.queryPage.page + 1
          this.total = rdata.total
        } else {
          this.queryPage.page = this.queryPage.page + 1
          this.warning(data.message)
        }
      }).catch((e) => {
        this.loading = false
        console.log('err', e)
      })
    },
    _getClassification() {
      getClassification().then((res) => {
        if (res.code === 200 && res.data) {
          this.classification = res.data
        }
      })
    },
    _resetNavHeight() {
      this.$nextTick(() => {
        const dom = this.$refs.nav;
        let offsetTop = dom.offsetTop;
        window.addEventListener(
          'scroll',
          e => {
            this.isScroll = true
            let scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
            if (this.timer) {
              clearTimeout(this.timer)
            }
            this.timer = setTimeout(() => {
              //滚动距离为包裹层距离内容层的高度
              if (scrollTop >= offsetTop) {
                this.isFixed = true;
              } else {
                this.isFixed = false;
              }
            }, 10)
          }, true)
      })
    },
    _jsSdkInit () {
      // let webUrl = window.location.protocol + '//' + window.location.hostname + this.$route.fullPath
      // let fullUrl = 'https://m.909.cn'+ this.$route.fullPath
      let fullUrl = this.fullUrl
      let query = {
        url: fullUrl
      }
      getJssdk(query).then((res) => {
        if (res.code === 200 && res.data) {
          let jssdk = res.data
          let wxConfig = {
            debug: false,
            appId: jssdk.appId,
            timestamp: parseInt(jssdk.timestamp),
            nonceStr: jssdk.nonceStr,
            signature: jssdk.signature,
            // jsApiList: jssdk.jsApiList
            jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
          }
          wx.config(wxConfig)
          this.jsSdk = res.data
          wx.error(function(res){
            console.log('err', res)
          });
          this._getWeChatShare()
        }
      })
    },
    _getWeChatShare() {
      let fullUrl = this.fullUrl
      //分享的参数
      let shareMsage = {
        title: '909数码',
        desc: '品牌旗舰机型,折扣多多,优惠多多。',
        link: fullUrl,
        imgUrl: 'https://api.909.cn/storage/images/202208/728b7256cf521268eaf72ec75cb58ff1.png'
      }
      wx.ready(function () {
        // 分享给朋友 分享到QQ
        wx.updateAppMessageShareData({ 
          title: shareMsage.title, // 分享标题
          desc: shareMsage.desc, // 分享描述
          link: shareMsage.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: shareMsage.imgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('分享给朋友设置成功')
          }
        })
        // 分享到朋友圈 分享到QQ空间
        wx.updateTimelineShareData({ 
          title: shareMsage.desc, // 分享标题
          link: shareMsage.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
          imgUrl: shareMsage.imgUrl, // 分享图标
          success: function () {
            // 设置成功
            console.log('分享到朋友圈，设置成功')
          }
        })
      });
    },
    reset() {
      this.queryPage = Object.assign({}, defaultPageData)
      this.list = [],
      this.price = 0
      this.total = 0
      this.isScroll = false
      this.categoryList = []
      
      this._jsSdkInit()
      this._getCategory()
      this._getClassification()
    },
    handleRoute(route) {
      if (route.name === 'home' || route.name === 'acting') {
        this.queryPage.category = this.$route.query.id
        this.queryPage.cid = this.$route.query.cid
        this.queryPage.keyword = this.$route.query.key
        this.reset()
      }
    }
  },
  watch: {
    '$route'(to, from) {
      this.handleRoute(to)
    },
    'bannerImg'(newVal, oldVal) {
      if (!this.isScroll) {
        let contact = newVal.find(item => {
          return item === 'contact'
        })
        let banner = newVal.find(item => {
          return item === 'banner'
        })
        if (contact && banner) {
          this._resetNavHeight()
        }
      }
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  },
  created() {
  }

}